/**
 * Kullanıcının günleri: üye olduğu + kurduğu. Kurallar: ownedGroups.test.ts (UG-01…UG-04).
 *
 * Canlı test bulgusu B-26 (18 Eylül 2026): organizatör kendine sıra almadığında
 * ("Listede yokum") kurduğu gün Günlerim'den kayboluyordu; ekranlar yalnız üyelikten
 * okuyordu. Kurduğu gün, üyeliği olmasa da kendisine görünmeli.
 */
export interface GroupRow {
  id: string
  name?: string
  status?: string
  member_count?: number
  [key: string]: unknown
}

const GORUNUR_DURUMLAR = new Set(['waiting', 'active', 'completed'])

export function mergeUserGroups(
  memberships: GroupRow[] | null | undefined,
  owned: GroupRow[] | null | undefined
): GroupRow[] {
  const sonuc: GroupRow[] = []
  const gorulen = new Set<string>()

  for (const group of memberships ?? []) {
    if (!group?.id || gorulen.has(group.id)) continue
    gorulen.add(group.id)
    sonuc.push(group)
  }

  for (const group of owned ?? []) {
    if (!group?.id || gorulen.has(group.id)) continue
    if (group.status && !GORUNUR_DURUMLAR.has(group.status)) continue
    gorulen.add(group.id)
    sonuc.push(group)
  }

  return sonuc
}
